export const module = {
  info: {
    name: 'voip-mrt-rate-division',
    caption: 'voip mrt rate division',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  nosideMenu: {
    topSeparator: false,
    caption: 'voip mrt rate division',
    icon: 'el-icon-folder',
    routeName: 'module->voip-mrt-rate-division->create',
    children: [
      {
        caption: 'Create MRT Division',
        icon: 'el-icon-plus',
        routeName: 'module->voip-mrt-rate-division->create'
      },
      {
        caption: 'List MRT Divisions',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-mrt-rate-division->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
